import Vue from 'vue'
import Router from "vue-router"

Vue.use(Router)

const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
	return originalPush.call(this, location).catch(err => err)
}

const router = new Router({
	mode: 'history',
	scrollBehavior: () => ({ y: 0 }),
	routes: [{
		path: "/",
		component: (resolve) => require(['@/view/main.vue'],resolve),
		children: [{
			path: '/',
			component: (resolve) => require(['@/view/Settings/basics.vue'],resolve),
		},{
			path: '/Goods/index.html',
			component: (resolve) => require(['@/view/Goods/index.vue'],resolve),
		},{
			path: '/Goods/off.html',
			component: (resolve) => require(['@/view/Goods/off.vue'],resolve),
		},{
			path: '/Goods/edit.html',
			component: (resolve) => require(['@/view/Goods/edit.vue'],resolve),
		},{
			path: '/Goods/add.html',
			component: (resolve) => require(['@/view/Goods/add.vue'],resolve),
		},{
			path: '/Goods/reject.html',
			component: (resolve) => require(['@/view/Goods/reject.vue'],resolve),
		},{
			path: '/Goods/reviewed.html',
			component: (resolve) => require(['@/view/Goods/reviewed.vue'],resolve),
		},{
			path: '/Goods/unreviewed.html',
			component: (resolve) => require(['@/view/Goods/unreviewed.vue'],resolve),
		},{
			path: '/Goods/price.html',
			component: (resolve) => require(['@/view/Goods/price.vue'],resolve),
		},{
			path: '/Category/index.html',
			component: (resolve) => require(['@/view/Category/index.vue'],resolve),
		},{
			path: '/Category/edit.html',
			component: (resolve) => require(['@/view/Category/edit.vue'],resolve),
		},{
			path: '/Category/add.html',
			component: (resolve) => require(['@/view/Category/add.vue'],resolve),
		},{
			path: '/Repertory/index.html',
			component: (resolve) => require(['@/view/Repertory/index.vue'],resolve),
		},{
			path: '/Repertory/in.html',
			component: (resolve) => require(['@/view/Repertory/in.vue'],resolve),
		},{
			path: '/Repertory/out.html',
			component: (resolve) => require(['@/view/Repertory/out.vue'],resolve),
		},{
			path: '/Repertory/outInwarehouse.html',
			component: (resolve) => require(['@/view/Repertory/outInwarehouse.vue'],resolve),
		},{
			path: '/Repertory/batchIn.html',
			component: (resolve) => require(['@/view/Repertory/batchIn.vue'],resolve),
		},{
			path: '/Repertory/batchOut.html',
			component: (resolve) => require(['@/view/Repertory/batchOut.vue'],resolve),
		},{
			path: '/Repertory/goodsIn.html',
			component: (resolve) => require(['@/view/Repertory/goodsIn.vue'],resolve),
		},{
			path: '/Repertory/goodsOut.html',
			component: (resolve) => require(['@/view/Repertory/goodsOut.vue'],resolve),
		},{
			path: '/Repertory/detail.html',
			component: (resolve) => require(['@/view/Repertory/detail.vue'],resolve),
		},{
			path: '/Indent/index.html',
			component: (resolve) => require(['@/view/Indent/index.vue'],resolve),
		},{
			path: '/Indent/cancel.html',
			component: (resolve) => require(['@/view/Indent/cancel.vue'],resolve),
		},{
			path: '/Indent/list.html',
			component: (resolve) => require(['@/view/Indent/list.vue'],resolve),
		},{
			path: '/Indent/complete.html',
			component: (resolve) => require(['@/view/Indent/complete.vue'],resolve),
		},{
			path: '/Indent/unfinished.html',
			component: (resolve) => require(['@/view/Indent/unfinished.vue'],resolve),
		},{
			path: '/Indent/dropShipping.html',
			component: (resolve) => require(['@/view/Indent/dropShipping.vue'],resolve),
		},{
			path: '/Indent/forGoods.html',
			component: (resolve) => require(['@/view/Indent/forGoods.vue'],resolve),
		},{
			path: '/Indent/return.html',
			component: (resolve) => require(['@/view/Indent/return.vue'],resolve),
		},{
			path: '/Indent/send.html',
			component: (resolve) => require(['@/view/Indent/send.vue'],resolve),
		},{
			path: '/Settings/role.html',
			component: (resolve) => require(['@/view/Settings/role.vue'],resolve),
		},{
			path: '/Settings/roleEdit.html',
			component: (resolve) => require(['@/view/Settings/roleEdit.vue'],resolve),
		},{
			path: '/Settings/index.html',
			component: (resolve) => require(['@/view/Settings/index.vue'],resolve),
		},{
			path: '/Settings/edit.html',
			component: (resolve) => require(['@/view/Settings/edit.vue'],resolve),
		},{
			path: '/Sms/index.html',
			component: (resolve) => require(['@/view/Sms/index.vue'],resolve),
		},{
			path: '/Address/index.html',
			component: (resolve) => require(['@/view/Address/index.vue'],resolve),
		},{
            path: '/Address/add.html',
            component: (resolve) => require(['@/view/Address/add.vue'],resolve),
        },{
            path: '/Address/edit.html',
            component: (resolve) => require(['@/view/Address/edit.vue'],resolve),
        },{
			path: '/Settings/freight.html',
			component: (resolve) => require(['@/view/Settings/freight.vue'],resolve),
		},{
			path: '/Settings/freightEdit.html',
			component: (resolve) => require(['@/view/Settings/freightEdit.vue'],resolve),
		},{
			path: '/Settings/basics.html',
			component: (resolve) => require(['@/view/Settings/basics.vue'],resolve),
		},{
			path: '/Settings/brandAuthorizing.html',
			component: (resolve) => require(['@/view/Settings/brandAuthorizing.vue'],resolve),
		},{
			path: '/Settings/brandAuthorizingEdit.html',
			component: (resolve) => require(['@/view/Settings/brandAuthorizingEdit.vue'],resolve),
		},{
			path: '/Finance/statement.html',
			component: (resolve) => require(['@/view/Finance/statement.vue'],resolve),
		},{
			path: '/Finance/audioStatement.html',
			component: (resolve) => require(['@/view/Finance/audioStatement.vue'],resolve),
		},{
			path: '/Finance/endStatement.html',
			component: (resolve) => require(['@/view/Finance/endStatement.vue'],resolve),
		},{
			path: '/Finance/water.html',
			component: (resolve) => require(['@/view/Finance/water.vue'],resolve),
		},{
			path: '/Finance/check.html',
			component: (resolve) => require(['@/view/Finance/check.vue'],resolve),
		},{
			path: '/Finance/detail.html',
			component: (resolve) => require(['@/view/Finance/detail.vue'],resolve),
		},{
			path: '/Finance/createbill.html',
			component: (resolve) => require(['@/view/Finance/createbill.vue'],resolve),
		}
		,{
			path: '/User/edit.html',
			component: (resolve) => require(['@/view/User/edit.vue'],resolve),
		},{
			path: '/Refund/index.html',
			component: (resolve) => require(['@/view/refund/index.vue'],resolve),
		},{
			path: '/Refund/edit.html',
			component: (resolve) => require(['@/view/refund/edit.vue'],resolve),
		}]
	},{
		path: "/login.html",
		component: (resolve) => require(['@/view/login.vue'],resolve),
	}]
})

const whiteList = ['/login.html']

router.beforeEach((to, from, next)=>{
	let token = localStorage.token
	let path = to.path.toLowerCase()
	if(token && path === '/login.html'){
		next({path:'/'})
	}else if(!token && whiteList.indexOf(path) === -1){
		next({
			path:"/login.html",
			query: {
				redirect: to.fullPath
			}
		})
	}else{
		next()
	}
})

export default router
